import apiClient from '@/core/api/';
import { convertToBlob } from '@/utils/utilities';

//constants
const itemBaseApiURL = 'api/item';
const accountBaseApiURL = 'api/account';
const incidentBaseApiURL = 'api/incident';

export const getDashboardInfo = async () =>
  await apiClient.get(`${itemBaseApiURL}/dashboardinfo`);

export const getInitCreateAccount = async (isEn = false) =>
  await apiClient.get(`${accountBaseApiURL}/initCreateAccount`, {
    params: {
      isEn,
    },
  });

export const getProfileInformation = async () =>
  await apiClient.get(`${accountBaseApiURL}/profile`);

export const createAccount = async (payload) =>
  await apiClient.post(accountBaseApiURL, payload);

export const getInitCatalog = async (isEn = false) =>
  await apiClient.get(`${itemBaseApiURL}/initcatalog`, {
    params: {
      isEn,
    },
  });

export const searchItems = async (payload, page = 1, pageSize = 10) =>
  await apiClient.post(
    `${itemBaseApiURL}/search?page=${page}&pageSize=${pageSize}`,
    payload
  );

export const saveRequest = async (payload) =>
  await apiClient.post(`${itemBaseApiURL}/saverequest`, payload);

export const getRequest = async (businessId) =>
  await apiClient.get(`${itemBaseApiURL}/request/${businessId}`);

export const getDocumentValidation = async (businessId, statusId) =>
  await apiClient.get(
    `${itemBaseApiURL}/request/documentvalidation/${businessId}/${statusId}`
  );

export const downloadItemAttachment = async (id) => {
  const { data } = await apiClient.get(`/api/itemattachment/download/${id}`);
  if (data) {
    convertToBlob(data);
  }
};

export const saveItemAttachment = (data) => {
  return apiClient.post('/api/itemattachment/saveitemattachment', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const removeItemAttachment = (documentId) =>
  apiClient.delete(`/api/itemattachment/remove/${documentId}`);

export const getAttachmentInitCatalog = async () =>
  await apiClient.get(`/api/itemattachment/initcatalog`);

export const submitRequest = async (itemId) =>
  await apiClient.post(`${itemBaseApiURL}/submitrequest/${itemId}`);

export const saveRatingSurvey = async (payload) =>
  await apiClient.post(`${itemBaseApiURL}/saverating`, payload);

export const sendIncidentReport = async (payload) =>
  await apiClient.post(`${incidentBaseApiURL}/sendincidentreport`, payload);

export const updateProfile = async (payload) =>
  await apiClient.put(`${accountBaseApiURL}/updateprofile`, payload);

export const getTrackingEntries = async (requestNumber) =>
  await apiClient.get(`${itemBaseApiURL}/trackingentries/${requestNumber}`);

export const addRequestComment = (businessId, commentText) =>
  apiClient.post(`${itemBaseApiURL}/addcomment`, {
    businessId,
    commentText,
  });

export const getRequestAutoSave = async () =>
  await apiClient.get(`${itemBaseApiURL}/requestautosave`);

export const saveRequestAutoSave = (payload) =>
  apiClient.post(`${itemBaseApiURL}/saverequestautosave`, payload);
